//import leituras from "~/pages/financeiro/leituras/index.vue"
//import form from "~/pages/financeiro/leituras/form.vue"
//import planilha from "~/pages/financeiro/leituras/planilha.vue"
export default {
    path: "leituras",
    component: () => import("~/pages/financeiro/leituras/index.vue"),
    children: [
    
        {
            path: "",
            component: () => import("~/pages/financeiro/leituras/form.vue"),
            meta: {
                isMainScreen: true,
            },
        },
        {
            path: "planilha",
            component: () => import("~/pages/financeiro/leituras/planilha.vue"),
        },
        
    ],
}